export default "__VITE_ASSET__DqXTX9NI__"